export default {
  path: '/agreement',
  meta: {
    title: '用户协议与隐私政策',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/agreement`),
}



// WEBPACK FOOTER //
// ./src/views/Agreement/router.js